import React from 'react';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  background?: 'white' | 'gray' | 'emerald';
}
export function Section({
  children,
  className = '',
  containerSize = 'xl',
  background = 'white',
  ...props
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    emerald: 'bg-emerald-900 text-white'
  };
  const sizes = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
  };
  return <section className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className}`} {...props} data-id="element-53">
      <div className={`mx-auto w-full ${sizes[containerSize]}`} data-id="element-54">{children}</div>
    </section>;
}